<template>
  <div
    :style="{'direction':'rtl'}"
    class="flex justify-center items-center h-full"
  >
    <feather-icon
      icon="EyeIcon"
      :svg-classes="actionClasses('view', 'hover:text-success')"
      @click="viewRecordDetails"
      v-show="actions.includes('view') && !actionsToHide.includes('view')"
      class="mx-2"
    />
    <feather-icon
      v-can="permissions.edit"
      icon="EditIcon"
      :svg-classes="actionClasses('edit', 'hover:text-primary')"
      @click="editRecord"
      v-show="actions.includes('edit') && !actionsToHide.includes('edit')"
      class="mx-2"
    />
    <feather-icon
      v-can="permissions.delete"
      icon="Trash2Icon"
      :svg-classes="actionClasses('delete', 'hover:text-danger')"
      @click="confirmDeleteRecord"
      v-show="actions.includes('delete') && !actionsToHide.includes('delete')"
      class="mx-2"
    />
    <feather-icon
      icon="ImageIcon"
      :svg-classes="actionClasses('image-preview-delete', 'hover:text-danger')"
      @click="confirmDeleteImage(deletePreviewImage)"
      v-show="actions.includes('image-preview-delete') && !actionsToHide.includes('image-preview-delete')"
      class="mx-2"
    />
    <feather-icon
      icon="ImageIcon"
      :svg-classes="actionClasses('image-delete', 'hover:text-danger')"
      @click="confirmDeleteImage(deleteImage)"
      v-show="actions.includes('image-delete') && !actionsToHide.includes('image-delete')"
      class="mx-2"
    />
    <feather-icon
      icon="RefreshCcwIcon"
      :svg-classes="actionClasses('change-password', 'hover:text-danger')"
      @click="changePassword"
      v-show="actions.includes('change-password') && !actionsToHide.includes('change-password')"
      class="mx-2"
    />
    <feather-icon
      icon="RepeatIcon"
      :svg-classes="actionClasses('repeat', 'hover:text-info')"
      @click="repeatAction"
      v-show="actions.includes('repeat') && !actionsToHide.includes('repeat')"
      class="mx-2"
    />
    <feather-icon
      icon="UsersIcon"
      :svg-classes="actionClasses('view-users', 'hover:text-primary')"
      @click="viewUsersRecord"
      v-show="actions.includes('view-users') && !actionsToHide.includes('view-users')"
      class="mx-2"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "AgTableBtnCell",
  data() {
    return {
      actionsToHide: [], //'view', 'edit', 'delete', 'image-delete', 'change-password', 'view-users'
      actionsToDisable: [], // نفس القيم، لكن تبقى الأيقونة ظاهرة ومعطّلة
      actions: ['view', 'edit', 'delete', 'image-delete', 'change-password', 'view-users'],
      permissions: {
        edit: null,
        delete: null
      }
    };
  },
  methods: {
    confirmDeleteRecord() {
      if (this.isActionDisabled('delete')) return;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'هل أنت متأكد من الحذف؟',
        text: `في حال الموافقة, لن تتمكن من التراجع!`,
        accept: this.deleteRecord,
        acceptText: 'حذف',
        cancelText: 'إلغاء',
      });
    },
    confirmDeleteImage(action) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'هل أنت متأكد من حذف الصورة؟',
        text: `في حال الموافقة, لن تتمكن من التراجع!`,
        accept: action,
        acceptText: 'حذف',
        cancelText: 'إلغاء',
      });
    },
    disableRecordActions() {
      if (!this.params.disabledRecordActions) return;

      const actionsToDisable = this.params.disabledRecordActions(this.params.data) || [];
      if (Array.isArray(actionsToDisable) && actionsToDisable.length > 0) {
        this.actionsToDisable = actionsToDisable;
      }
    },
    isActionDisabled(action) {
      return this.actionsToDisable.includes(action);
    },
    actionClasses(action, hoverClass) {
      if (this.isActionDisabled(action)) return 'h-7 w-7 opacity-25 cursor-not-allowed';
      return 'h-7 w-7 ' + hoverClass + ' cursor-pointer';
    },
    hideRecordActions() {
      if (!this.params.hideRecordActions) return;

      const actionsToHide = this.params.hideRecordActions(this.params.data) || [];
      if (Array.isArray(actionsToHide) && actionsToHide.length > 0) {
        this.actionsToHide = actionsToHide;
      }
    },
    deleteRecord() {
      if (this.isActionDisabled('delete')) return;
      this.params.deleteRecord(this.params.value, this.params.rowIndex);
    },
    deleteImage() {
      if (this.isActionDisabled('image-delete')) return;
      this.params.deleteImage(this.params.value, this.params.rowIndex);
    },
    deletePreviewImage() {
      if (this.isActionDisabled('image-preview-delete')) return;
      this.params.deletePreviewImage(this.params.value, this.params.rowIndex);
    },
    editRecord() {
      if (this.isActionDisabled('edit')) return;
      this.params.editRecord(this.params.data);
    },
    repeatRecord() {
      if (this.isActionDisabled('repeat')) return;
      this.params.repeatRecord(this.params.value);
    },
    viewUsersRecord() {
      if (this.isActionDisabled('view-users')) return;
      this.params.viewUsersRecord(this.params.value);
    },
    repeatAction() {
      if (this.isActionDisabled('repeat')) return;
      // بعض الشاشات تفتح نموذجاً بدل تنفيذ التكرار مباشرة، فلا حاجة لتأكيد
      if (this.params.confirmRepeat === false) return this.repeatRecord();
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'هل أنت متأكد من التكرار',
        text: `في حال الموافقة, لن تتمكن من التراجع!`,
        accept: this.repeatRecord,
        acceptText: 'نأكيد'
      });
    },
    changePassword() {
      if (this.isActionDisabled('change-password')) return;
      this.params.changePassword(this.params.data);
    },
    viewRecordDetails() {
      if (this.isActionDisabled('view')) return;
      this.params.viewRecordDetails(this.params.data);
    },
    isAdmin() {
      const roles = JSON.parse(localStorage.getItem('user')).user.roles.map((role) => role.name);
      if ((roles.includes('super_admin')) || (roles.includes('group_manager')))
        return true;
      else return !!this.params.actions.includes('raven');
    }
  },
  mounted() {
    this.hideRecordActions();
    this.disableRecordActions();
  },
  created() {
    if (this.params.actions) this.actions = this.params.actions;
    if (this.params.permissions) this.permissions = this.params.permissions;
  }
});
</script>
